import React, {Component} from 'react';
import './BoxCheckScanProgressCard.css';
import Card from "../../../card/Card";
import Label from "../../../label/Label";
import PrimaryButton from "../../../primaryButton/PrimaryButton";
import ProgressBar from "../progressBar/ProgressBar";
import models from '../../../../model/models';

export default class BoxCheckScanProgressCard extends Component{
	constructor(props) {
		super(props);
		this.state = {
			drugCodesChecked: this.props.drugCodesChecked,

		}
	}
	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({drugCodesChecked:nextProps.drugCodesChecked})
	}

	render(){
		const total = this.props.drugs.length;
		const progress = this.state.drugCodesChecked.length;
		let typeProgress = {progress:0, total:0};
		let typeName= '';
		if(this.state.lastDrugScanned){
			typeProgress = getTypeProgress(this.state.lastDrugScanned.type, this.props.drugs, this.state.drugCodesChecked);
			typeName = models.drug_type.obj(this.state.lastDrugScanned.type)?.name || '';
		}
    return(
    <Card className="g-box-check-scan-progress-card">
			<Label center medium dark>Scan all the drugs in the box</Label>
			<ProgressBar className={typeProgress.progress === typeProgress.total ? 'out':'' } name={typeName} progress={typeProgress.progress} total={typeProgress.total}/>
			<ProgressBar progress={progress} total={total}/>
			<PrimaryButton onClick={this.props.onContinue} center>Continue</PrimaryButton>
    </Card>
    )
  }
}
const getTypeProgress = (type, drugs, drugCodesChecked) => {
	const total = drugs.filter(drug => drug.type === type).length;
	const progress = drugs.filter(drug => 
		drug.type === type && drugCodesChecked.includes(drug.barcode_id)
	).length;
	
	return {total, progress}
};